<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['listEmail', getSelectedDEV && 'dev-selected-component']"
  >
    <ul v-if="value || emailsDev">
      <li v-for="(email, i) in (value && value.split(';')) || emailsDev" :key="i">
        <v-icon
          v-if="schema.appendIcon && schema.appendIcon.left"
          v-bind="schema.appendIcon.attributesIcon"
        >{{ schema.appendIcon.icon }}</v-icon>
        <span v-bind="schema.attributes">{{ email }}</span>
        <v-icon
          v-if="schema.appendIcon && schema.appendIcon.right"
          v-bind="schema.appendIcon.attributesIcon"
        >{{ schema.appendIcon.icon }}</v-icon>
      </li>
    </ul>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin]
};
</script>

<style lang="scss" scoped>
.listEmail {
  ul {
    list-style: none;
    display: flex;
    padding: 0;
    flex-wrap: wrap;
    justify-content: center;

    li {
      display: flex;
      margin-bottom: 10px;
      margin-right: 15px;
    }
  }
}

.listVerticalLeft {
  ul {
    justify-content: unset;
    flex-direction: column;
  }
}

.listVerticalRight {
  ul {
    justify-content: unset;
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
